export const blockIconsContentFlag = (
	<span className='material-symbols-outlined'>flag</span>
);
